exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".aUgoSRD41qkbDKM5_8Pwa{width:100%;padding:30px 40px 40px 40px;display:flex}._21QFLyZDjm8cJ4BFOR9sj5{flex:1;min-width:0px;margin-right:40px}.FgADAJ0rVP4NyeSsK1Cij{width:280px;flex:0 0 280px}._1OLHSdhKkjSngWtiRxp7h-{flex:1;min-width:0px;height:100%}\n", ""]);

// Exports
exports.locals = {
	"container": "aUgoSRD41qkbDKM5_8Pwa",
	"mainColumn": "_21QFLyZDjm8cJ4BFOR9sj5",
	"sideColumn": "FgADAJ0rVP4NyeSsK1Cij",
	"editorColumn": "_1OLHSdhKkjSngWtiRxp7h-"
};